// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SubjectDetails.css */

.subject-details-container {
  font-family: Arial, sans-serif;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.search-form-container {
  text-align: center;
  margin: 20px 0;
}

.search-form-container form {
  display: flex;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.search-form-container label {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  font-weight: 500;
  color: #212529;
}

.search-form-container select {
  padding: 12px 15px;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  font-size: 16px;
  background-color: #f8f9fa;
  color: #212529;
  min-width: 200px;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.search-form-container select:hover {
  border-color: #ced4da;
  background-color: #e9ecef;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.search-form-container select:focus {
  outline: none;
  border-color: #90caf9;
  box-shadow: 0 0 0 3px rgba(144, 202, 249, 0.2);
}

.search-form-container button {
  padding: 12px 24px;
  background-color: #e3f2fd;
  color: #1976d2;
  border: 1px solid #90caf9;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  height: fit-content;
  margin-top: auto;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  font-weight: 500;
}

.search-form-container button:hover {
  background-color: #bbdefb;
  border-color: #64b5f6;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.search-form-container button:active {
  background-color: #90caf9;
  transform: translateY(1px);
}

.tabs-container {
  text-align: center;
  margin-top: 20px;
}

.tabs-container button {
  padding: 10px 20px;
  border: 1px solid #004d99;
  background-color: #fff;
  color: #004d99;
  border-radius: 4px;
  margin: 0 5px;
  cursor: pointer;
  font-size: 1em;
}

.tabs-container button.active {
  background-color: #004d99;
  color: #fff;
}

.content-container {
  margin-top: 30px;
}

.papers-list {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.paper-row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 20px;
  margin-bottom: 20px;
  width: 100%;
}

.paper-button {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 15px 20px;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;
  text-align: center;
  font-size: 16px;
  color: #212529;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.paper-button:hover {
  background-color: #e9ecef;
  border-color: #ced4da;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.paper-button:disabled {
  background-color: #e9ecef;
  border-color: #dee2e6;
  color: #6c757d;
  cursor: not-allowed;
  opacity: 0.7;
}

.paper-button.qp {
  background-color: #e3f2fd;
  border-color: #90caf9;
  color: #1976d2;
}

.paper-button.ms {
  background-color: #f3e5f5;
  border-color: #ce93d8;
  color: #7b1fa2;
}

.paper-button.in {
  background-color: #e8f5e9;
  border-color: #a5d6a7;
  color: #388e3c;
}

.resources-list {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
}

.paper-item {
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  padding: 15px;
  border-radius: 8px;
  width: 300px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.paper-item h3 {
  margin-top: 0;
}

.paper-item ul {
  list-style-type: none;
  padding: 0;
}

.paper-item li {
  padding: 5px 0;
  font-size: 0.95em;
}

.footer-links {
  text-align: center;
  margin-top: 40px;
  font-size: 1em;
}

.footer-links a {
  color: #004d99;
  text-decoration: none;
  margin: 0 5px;
}

.footer-links a:hover {
  text-decoration: underline;
}

/* Spinner styles for loading animations */
.loading-spinner {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 16px;
  color: #212529;
  margin: 10px 0;
}

.spinner {
  width: 20px;
  height: 20px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Add styles for search-input fields */
.search-input {
  padding: 8px 12px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  background-color: #1976d2;
  font-size: 16px;
  margin-bottom: 8px;
  min-width: 200px;
  outline: none;
}

.search-input:focus {
  border-color: #90caf9;
  box-shadow: 0 0 0 3px rgba(144, 202, 249, 0.2);
}

/* Mobile layout for paper rows */
@media (max-width: 768px) {
  .paper-row {
    grid-template-columns: 1fr;
    gap: 10px;
  }
  .paper-button {
    width: 100%;
  }
}
/* End of mobile styles */

/* Dark Mode Overrides */
body.dark-mode label {
  color: #fff;
}

body.dark-mode .paper-button {
  background-color: #444;
  color: #fff;
  border: 1px solid #444;
}

body.dark-mode .paper-button:hover {
  background-color: #333;
  border-color: #333;
} `, "",{"version":3,"sources":["webpack://./src/components/SubjectDetails.css"],"names":[],"mappings":"AAAA,uBAAuB;;AAEvB;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,0CAA0C;AAC1C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,uCAAuC;AACvC;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA,iCAAiC;AACjC;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;EACA;IACE,WAAW;EACb;AACF;AACA,yBAAyB;;AAEzB,wBAAwB;AACxB;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB","sourcesContent":["/* SubjectDetails.css */\n\n.subject-details-container {\n  font-family: Arial, sans-serif;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 20px;\n}\n\n.search-form-container {\n  text-align: center;\n  margin: 20px 0;\n}\n\n.search-form-container form {\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n  flex-wrap: wrap;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 20px;\n}\n\n.search-form-container label {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n  font-weight: 500;\n  color: #212529;\n}\n\n.search-form-container select {\n  padding: 12px 15px;\n  border: 1px solid #dee2e6;\n  border-radius: 8px;\n  font-size: 16px;\n  background-color: #f8f9fa;\n  color: #212529;\n  min-width: 200px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.search-form-container select:hover {\n  border-color: #ced4da;\n  background-color: #e9ecef;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.search-form-container select:focus {\n  outline: none;\n  border-color: #90caf9;\n  box-shadow: 0 0 0 3px rgba(144, 202, 249, 0.2);\n}\n\n.search-form-container button {\n  padding: 12px 24px;\n  background-color: #e3f2fd;\n  color: #1976d2;\n  border: 1px solid #90caf9;\n  border-radius: 8px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  height: fit-content;\n  margin-top: auto;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  font-weight: 500;\n}\n\n.search-form-container button:hover {\n  background-color: #bbdefb;\n  border-color: #64b5f6;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.search-form-container button:active {\n  background-color: #90caf9;\n  transform: translateY(1px);\n}\n\n.tabs-container {\n  text-align: center;\n  margin-top: 20px;\n}\n\n.tabs-container button {\n  padding: 10px 20px;\n  border: 1px solid #004d99;\n  background-color: #fff;\n  color: #004d99;\n  border-radius: 4px;\n  margin: 0 5px;\n  cursor: pointer;\n  font-size: 1em;\n}\n\n.tabs-container button.active {\n  background-color: #004d99;\n  color: #fff;\n}\n\n.content-container {\n  margin-top: 30px;\n}\n\n.papers-list {\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 20px;\n}\n\n.paper-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 20px;\n  margin-bottom: 20px;\n  width: 100%;\n}\n\n.paper-button {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 8px;\n  padding: 15px 20px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  width: 100%;\n  text-align: center;\n  font-size: 16px;\n  color: #212529;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 60px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.paper-button:hover {\n  background-color: #e9ecef;\n  border-color: #ced4da;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.paper-button:disabled {\n  background-color: #e9ecef;\n  border-color: #dee2e6;\n  color: #6c757d;\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.paper-button.qp {\n  background-color: #e3f2fd;\n  border-color: #90caf9;\n  color: #1976d2;\n}\n\n.paper-button.ms {\n  background-color: #f3e5f5;\n  border-color: #ce93d8;\n  color: #7b1fa2;\n}\n\n.paper-button.in {\n  background-color: #e8f5e9;\n  border-color: #a5d6a7;\n  color: #388e3c;\n}\n\n.resources-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n  justify-content: center;\n}\n\n.paper-item {\n  background-color: #f9f9f9;\n  border: 1px solid #ddd;\n  padding: 15px;\n  border-radius: 8px;\n  width: 300px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.paper-item h3 {\n  margin-top: 0;\n}\n\n.paper-item ul {\n  list-style-type: none;\n  padding: 0;\n}\n\n.paper-item li {\n  padding: 5px 0;\n  font-size: 0.95em;\n}\n\n.footer-links {\n  text-align: center;\n  margin-top: 40px;\n  font-size: 1em;\n}\n\n.footer-links a {\n  color: #004d99;\n  text-decoration: none;\n  margin: 0 5px;\n}\n\n.footer-links a:hover {\n  text-decoration: underline;\n}\n\n/* Spinner styles for loading animations */\n.loading-spinner {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 16px;\n  color: #212529;\n  margin: 10px 0;\n}\n\n.spinner {\n  width: 20px;\n  height: 20px;\n  border: 2px solid #f3f3f3;\n  border-top: 2px solid #3498db;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n/* Add styles for search-input fields */\n.search-input {\n  padding: 8px 12px;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  background-color: #1976d2;\n  font-size: 16px;\n  margin-bottom: 8px;\n  min-width: 200px;\n  outline: none;\n}\n\n.search-input:focus {\n  border-color: #90caf9;\n  box-shadow: 0 0 0 3px rgba(144, 202, 249, 0.2);\n}\n\n/* Mobile layout for paper rows */\n@media (max-width: 768px) {\n  .paper-row {\n    grid-template-columns: 1fr;\n    gap: 10px;\n  }\n  .paper-button {\n    width: 100%;\n  }\n}\n/* End of mobile styles */\n\n/* Dark Mode Overrides */\nbody.dark-mode label {\n  color: #fff;\n}\n\nbody.dark-mode .paper-button {\n  background-color: #444;\n  color: #fff;\n  border: 1px solid #444;\n}\n\nbody.dark-mode .paper-button:hover {\n  background-color: #333;\n  border-color: #333;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
